import { useCallback, useEffect, useMemo, useState } from "react";
import { Cookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { publicRequest } from "@/services";
import { LoginResponseSchema, AuthenSchema } from "@/schemas";
import {  Flex, Typography } from "antd";
import FlatButton from "@/components/button/button";

const authorization = async (body: AuthenSchema) => {
  try {

    const result = await publicRequest<AuthenSchema, LoginResponseSchema>({
      url: "/authen",
      method: "POST",
      data: body,
    });
    return result;
  } catch (error) {
    throw error;
  }
};

const IPAuthenticationScreen: React.FC = () => {
  const navigate = useNavigate();

  const cookies = useMemo(() => new Cookies(null, { path: '/' }), [])

  const clearSession = useCallback(async () => {
    await cookies.remove("code")
    await cookies.remove("refresh-token-expires-in")
    await cookies.remove("token-expires-in")
    await localStorage.removeItem("login-type")
    navigate('/', { replace: true });
  }, [navigate, cookies]);

  const handleAuthorization = useCallback(async (callback: () => void) => {
    try {
      var token = localStorage.getItem("token")
      const body = {
        access_token: token ?? "",
      };
      const userInfo: any = await authorization(body);

      if (userInfo.code != 200) {
        clearSession();
      } else {
        callback();
      }

    } catch (error) {
      clearSession()
    }
  }, [cookies, clearSession]);

  useEffect(() => {
    handleAuthorization(() => {});
  }, []);


  const onNavigateToWebServerA = useCallback(async () => {
    handleAuthorization(() => {
      navigate("/web-server-a");
    });
  }, []);

  const onNavigateToWebServerB = useCallback(async () => {
    handleAuthorization(() => {
      navigate("/web-server-b");
    });
  }, []);


  return (
    <Flex gap="middle" align="center" vertical>
      <Typography.Text style={{ fontSize: 24, color: "#40C1A2" }}>
      AuthPOC（デモ）画面
      </Typography.Text>
      <FlatButton
        size="large"
        type="primary"
        style={{ width: 360 }}
        onClick={onNavigateToWebServerA}
      >
       WebServer-Aへ接続
      </FlatButton>
      <FlatButton
        size="large"
        type="primary"
        style={{ width: 360 }}
        onClick={onNavigateToWebServerB}
      >
      WebServer-Bへ接続
      </FlatButton>
      <FlatButton
        size="large"
        type="primary"
        style={{ width: 360 }}
        onClick={clearSession}
      >
      終了
      </FlatButton>
    </Flex>
  );
};

export default IPAuthenticationScreen;
